"use strict";

// jQuery free

(function () {
  const CLASS_AJAX = 'ajax';
  const DATA_AJAX_INIT = 'data-ajax-init';
  const DATA_AJAX_HREF = 'data-ajax-href';
  const DATA_AJAX_SHOW_LOADER = 'data-ajax-show-loader';
  const DATA_AJAX_INCLUDE_DATETIME = 'data-ajax-include-datetime';
  const DATA_AJAX_SEND_ONENTER = 'data-ajax-send-onenter';
  let sendOnEnterElement = null;
  function isObject(x) {
    return typeof x === 'object' && !Array.isArray(x) && x !== null;
  }
  function processPayload(payload) {
    if (typeof payload === 'string') {
      payload = {
        modal: payload
      };
    }
    if (!isObject(payload)) {
      return payload;
    }
    for (const key in payload) {
      if (!['snippets', 'flashMessages', 'state', 'modal', 'dataLayer', 'redirect'].includes(key)) {
        window.KMPayload[key] = payload[key];
      }
    }
    if (!processPayloadRedirect(payload)) {
      processPayloadFlashMessages(payload);
      processPayloadModal(payload);
      processPayloadSnippets(payload);
      processPayloadDataLayer(payload);
      document.dispatchEvent(new CustomEvent('kvik_event_ajax_payload', {
        detail: payload
      }));
    }
  }
  function initElement(element) {
    if (element.hasAttribute(DATA_AJAX_INIT)) {
      return;
    }
    element.setAttribute(DATA_AJAX_INIT, '1');
    let eventName = 'click';
    if (element.tagName === 'FORM') {
      eventName = 'submit';
    }
    element.addEventListener(eventName, function (event) {
      event.preventDefault();
      sendAjax(element);
    });
  }
  function sendAjax(urlOrElement) {
    let url, element;
    if (urlOrElement instanceof HTMLElement) {
      if (urlOrElement.hasAttribute(DATA_AJAX_SHOW_LOADER)) {
        window.kvik_modal.showLoader();
      }
      url = getUrlFromElement(urlOrElement);
      element = urlOrElement;
      if (element.hasAttribute('data-ajax-persist-scroll')) {
        window.kvik_modal.setPendingScrollRestore();
      }
    } else if (typeof urlOrElement === "string") {
      url = urlOrElement;
      element = null;
      window.kvik_modal.showLoader();
    }
    if (!url) {
      console.warn('No URL for element', element);
      return;
    }
    if (element && element.getAttribute(DATA_AJAX_INCLUDE_DATETIME)) {
      url += '&datetime=' + new Date().toISOString();
    }
    const config = {
      method: 'GET',
      mode: 'same-origin',
      // send cookies _nss for isSameSite()
      headers: {
        'X-Requested-With': 'XMLHttpRequest' // To force Nette isAjax() to be true.
      }
    };
    if (element && element.tagName === 'FORM') {
      config.method = element.method.toUpperCase();
      config.body = getFormElementWwwUrlEncoded(element);
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.cache = 'no-store';
    }
    fetch(url, config).then(response => {
      if (response.headers.get('Content-Type').includes('json')) {
        return response.json();
      }
      return response.text();
    }).then(payload => processPayload(payload)).catch(error => {
      console.error(error);
    });
  }
  function sendRequestFromElement(element) {
    if (element.classList.contains(CLASS_AJAX)) {
      sendAjax(element);
    } else if (element.tagName === 'FORM') {
      window.kvik_modal.showLoader();
      element.submit();
    } else {
      const url = getUrlFromElement(element);
      if (url) {
        window.kvik_modal.showLoader();
        location.href = url;
      } else {
        console.warn('No request from element.', element);
      }
    }
  }
  function getUrlFromElement(element) {
    if (element.hasAttribute(DATA_AJAX_HREF)) {
      return element.getAttribute(DATA_AJAX_HREF);
    }
    if (element.tagName === 'FORM') {
      return element.getAttribute('action');
    }
    return element.getAttribute('href');
  }

  /**
   * @see https://ultimatecourses.com/blog/transform-formdata-into-query-string
   */
  function getFormElementWwwUrlEncoded(formElement) {
    const formData = new FormData(formElement);
    const data = [...formData.entries()];
    const wwwUrlEncoded = data.map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`).join('&');
    console.debug(wwwUrlEncoded);
    return wwwUrlEncoded;
  }
  function processPayloadDataLayer(payload) {
    if (payload.dataLayer && Array.isArray(payload.dataLayer)) {
      for (let i = 0; i < payload.dataLayer.length; i++) {
        const message = payload.dataLayer[i];
        if (Array.isArray(message)) {
          window.gtag.apply(window, message);
        } else {
          window.dataLayer.push(message);
        }
      }
    }
  }
  function processPayloadRedirect(payload) {
    if (payload.redirect) {
      window.location.href = payload.redirect;
      return true;
    }
    return false;
  }
  function processPayloadFlashMessages(payload) {
    if (payload.flashMessages && payload.flashMessages.length) {
      const messages = [];
      for (let i = 0; i < payload.flashMessages.length; i++) {
        messages.push(payload.flashMessages[i].message);
      }
      window.kvik_modal.showModal(messages.join('<br>'));
    }
  }
  function processPayloadModal(payload) {
    if (payload.modal) {
      window.kvik_modal.showModal(payload.modal);
    }
  }
  function processPayloadSnippets(payload) {
    if (payload.snippets) {
      for (let id in payload.snippets) {
        const element = document.getElementById(id);
        element.innerHTML = payload.snippets[id];
        document.dispatchEvent(new CustomEvent('kvik_event_ajax_one_snippet_update', {
          detail: {
            element: element,
            snippetId: id
          }
        }));
      }
      initInDOM();
      document.dispatchEvent(new CustomEvent('kvik_event_ajax_snippets_update'));
    }
  }
  function initInDOM() {
    const kmAjaxElements = document.body.getElementsByClassName(CLASS_AJAX);
    for (let i = 0; i < kmAjaxElements.length; i++) {
      initElement(kmAjaxElements[i]);
    }
    sendOnEnterElement = document.querySelector(`[${DATA_AJAX_SEND_ONENTER}]`);
  }
  onDOMReady(function () {
    if (window.KMPayload) {
      processPayload(window.KMPayload);
    }
    initInDOM();
    document.addEventListener('kvik_event_modal_show_modal', function (event) {
      initInDOM();
    });
  });
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Enter' && sendOnEnterElement) {
      sendRequestFromElement(sendOnEnterElement);
    }
  });
  window.kvik_ajax = {
    processPayload,
    initElement,
    sendAjax,
    sendRequestFromElement,
    DATA_AJAX_SHOW_LOADER
  };
})();